import { render, staticRenderFns } from "./ChatBoxAudioRecorder.vue?vue&type=template&id=10563a28&scoped=true&"
import script from "./ChatBoxAudioRecorder.vue?vue&type=script&lang=js&"
export * from "./ChatBoxAudioRecorder.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxAudioRecorder.vue?vue&type=style&index=0&id=10563a28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10563a28",
  null
  
)

export default component.exports